var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSessions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 85.748,
    viewBox: "0 0 119 85.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b,.d{fill:#fff;stroke-width:2px;}.b{stroke:#c8d1ec;}.c{fill:#c8d1ec;}.d{stroke:#c8d1ec;}.e{stroke:none;}.f{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-139 -208.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 59,
    height: 20,
    rx: 10,
    transform: "translate(139 264)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 56,
    height: 20,
    rx: 10,
    transform: "translate(190 249)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 59,
    height: 20,
    rx: 10,
    transform: "translate(199 274)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(156 232)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 5,
    cy: 5,
    r: 4
  })), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(150 227)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(215 248)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(209 239)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4,
    cy: 4,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(148 243)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4,
    cy: 4,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18049.002 11682.622)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M28.634,66.8H4.251A4.251,4.251,0,0,1,0,62.554V8.483a4.248,4.248,0,0,1,4.25-4.236H6.359V3.421C6.359,1.535,7.313,0,8.485,0h15.9c1.172,0,2.126,1.535,2.126,3.421v.826h2.125A4.241,4.241,0,0,1,32.87,8.483v54.07A4.243,4.243,0,0,1,28.634,66.8ZM12.8,39.46h0L11.139,51.693a1.126,1.126,0,0,0,1.115,1.276,1.138,1.138,0,0,0,.253-.029,1.121,1.121,0,0,0,.692-.486L26.612,31.678a1.124,1.124,0,0,0-1.2-1.706L20.69,31.063,22,18.887a1.125,1.125,0,0,0-2.071-.719L6.915,38.844a1.125,1.125,0,0,0,1.206,1.7L12.8,39.46Z",
    transform: "translate(-17878.002 -11474.37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSessions);
export default __webpack_public_path__ + "static/media/no_sessions.148977d0f39d0e2134724ca88af30417.svg";
export { ForwardRef as ReactComponent };